<template>
	<div class="containerPage">
		<div class="content">
			<div class="search">
				<el-input v-model="search.name" size="small" style="max-width: 200px;"
					:placeholder="$t('articleUnlock.keys')">
				</el-input>
				<el-button style="margin-left: 5px;margin-right: 5px;" class="search-btn" size="small"
					@click="handleClick">{{$t('articleUnlock.inquire')}}
				</el-button>
			</div>

			<template v-for="item in worksList">
				<div class="items">
					<div class="list">
						<div class="work-right">
							<div class="work-left">
								<!-- <img width="120" height="160" :src="baseApi +'/'+ item.works.converPath"> -->
								<el-image class="work-image" fit="fill" :src="baseApi +'/' + item.works.converPath"
									lazy>
									<img slot="error" src="../../assets/img/defaultBg.png" fit="fill" />
								</el-image>
								<div class="work_bottom">
									<div class="vipBox">
										<div class="vipBox-label">{{$t('workList.VIP')}}</div>
										<div class="vipBox-value">{{numberFormat(item.count.vipChapterCount)}}</div>
										<!-- <div class="vipBox-value">{{numberFormat(item.vipChapter)}}</div> -->
									</div>

									<div class="statusBox">
										<div class="statusBox-label">{{$t('workList.status')}}</div>
										<div class="statusBox-value">
											<!-- 	<el-tag v-if="item.works.signStatus==1" type="warning">Approved</el-tag>
											<el-tag v-if="item.works.signStatus==2" type="warning">Rejected</el-tag>
											<el-tag v-if="item.works.signStatus==3" type="warning">Under Review</el-tag>
											<el-tag v-if="item.works.signStatus==100"
												type="warning">Uncontracted</el-tag> -->

											<div v-if="item.works.contractStatus==null && item.works.signStatus==100">
												Uncontracted</div>
											<div v-if="item.works.contractStatus==null && item.works.signStatus==1">
												Approved</div>
											<div v-if="item.works.contractStatus==null && item.works.signStatus==2">
												Rejected</div>
											<div v-if="item.works.contractStatus==null && item.works.signStatus==3">
												Under Review</div>
											<div v-if="item.works.contractStatus!=null && item.works.contractStatus==1">
												Signed</div>
											<div v-if="item.works.contractStatus!=null && item.works.contractStatus==2">
												Failed</div>
											<div v-if="item.works.contractStatus!=null && item.works.contractStatus==3">
												Under Review</div>
											<!-- <div v-if="item.works.signStatus===1">Approved</div>
									    <div v-if="item.works.signStatus===2">Rejected</div>
									    <div v-if="item.works.signStatus===3">Under Review</div>
									    <div v-if="item.works.signStatus===100">Uncontracted</div> -->
										</div>
									</div>
								</div>
							</div>
							<div class="work-right-info">
								<div class="name">{{item.works.worksName}}</div>
								<!-- <div class="chapter">{{$t('workList.introduction')}}{{item.works.introduction}}</div> -->
								<div class="chapter">{{userInfo.pseudonym}}</div>
								<div class="shoucang"><span style="font-weight: bold;">{{$t('workList.Story_ID')}}:
									</span><span style="font-weight: 600;"> {{item.works.bookNo}}</span></div>
								<div class="shoucang"><span style="font-weight: 600;">{{$t('workList.Release_time')}}:
										{{formatlocalDate(item.works.firstPublishTime)}}</span></div>
								<div class="shoucang">
									<div class="workCount">
										<img src="../../assets/img/eye.png" alt="">
										<span>{{numberFormat(item.count.readCount)}}</span>
									</div>
									<div class="workCount">
										<img src="../../assets/img/love.png" alt="">
										<span>{{numberFormat(item.count.bookShelfCount)}}</span>
									</div>
									<div class="workCount">
										<img src="../../assets/img/comment.png" alt="">
										<span>{{numberFormat(item.count.commentCount)}}</span>
									</div>
									<div class="workCount1">
										<img src="../../assets/img/chapterNum.png" alt="">
										<span>{{numberFormat(item.publishChapter)}}</span>
									</div>
								</div>
								<div class="wordCountStyle">
									<div class="wordCountStyle-label">{{$t('workList.workCount')}}</div>
									<div class="wordCountStyle-num" style="padding-left: 5px;">
										{{numberFormat(item.works.words)}}</div>
								</div>
							</div>

							<div class="doms">
								<div class="sheding">
								</div>
								<div class="btn them-btn">
									<el-button v-show="!isOperator" type="warning" class="zhu-btn info-updata-btn"
										size="mini" style="font-weight: 400;" @click="toEditor(item)">
										{{$t('workList.Edit')}}
									</el-button>
									<!-- 									<el-button v-show="!isOperator" type="warning" class="zhu-btn info-updata-btn"
										size="mini" style="font-weight: 400;" @click="toSetting(item)">
										{{$t('workList.ConceptualWork')}}
									</el-button> -->
									<el-tooltip v-if="(item.works.signStatus==100)"
										:disabled="!(item.draftWords<=5000)"
										content="A contract applicationis eligible with aminimum of 5,ooowords in the draft folder."
										placement="bottom" effect="light">
										<span>
											<el-button type="warning" class="zhu-btn info-updata-btn" size="mini"
												style="font-weight: 400;" @click="tosigning(item)"
												:disabled='item.works.signStatus==1 ||item.draftWords<=5000'>
												{{$t('workList.SignApplication')}}
											</el-button>
										</span>
									</el-tooltip>
									<el-button v-if="!(item.works.signStatus==100)" type="warning"
										class="zhu-btn info-updata-btn" size="mini" style="font-weight: 400;"
										@click="toViewProcess(item)">
										{{$t('workList.SignProcess')}}
									</el-button>

									<el-button v-show="!isOperator" type="warning" class="zhu-btn info-updata-btn"
										size="mini" style="font-weight: 400;" @click="toPublished(item)">
										Chapter list
									</el-button>
									<el-button v-show="!isOperator" type="warning" class="zhu-btn info-updata-btn"
										size="mini" style="font-weight: 400;" @click="toWriting(item)">
										{{$t('workList.writing')}}
									</el-button>
								</div>
							</div>
						</div>

					</div>
					<div class="setting" v-show="false">
						<div class="row them-btn">
							<el-select multiple v-model="settingList" size="mini" :placeholder="$t('workList.choose')"
								style="margin-right: 10px;">
								<el-option label="$t('workList.NewSettingCategory')" value="新建设定分类" />
								<el-option label="$t('workList.characterDesign')" value="人物设定" />
								<el-option label="$t('workList.set')" value="背景设定" />
								<el-option label="$t('workList.otherSet')" value="其他设定" />
							</el-select>
							<el-button class="info-updata-btn" size="mini" style="font-weight: 400;">
								{{$t('workList.DeleteCategory')}}
							</el-button>
							<el-button class="info-updata-btn" size="mini" style="font-weight: 400;">
								{{$t('workList.DeleteCategory')}}
							</el-button>
							<el-button type="warning" class="zhu-btn info-updata-btn" size="mini"
								style="font-weight: 400;" @click="addSettingByBook">
								{{$t('workList.newSet')}}
							</el-button>
						</div>
						<div class="value-item">
							<div class="item-btn">
								<span @click="deleteSetting"><i
										class="el-icon-delete"></i>{{$t('workList.Delete')}}</span>
								<span @click="editSetting"><i class="el-icon-edit"></i>{{$t('workList.Edit')}}</span>
							</div>
							<div class="info noinputbox">
								<el-input style="border:0px;" size="mini" class="name" value="自定义" :readonly="true">
								</el-input>
								<el-input class="item-content" type="textarea" resize="none" autosize value="自义定内容"
									:readonly="true"></el-input>
								<!-- <div class="name">自定义</div> -->
								<!-- <div class="item-content" style="margin: 5px 0;">自义定内容</div> -->
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-show="worksList.length<=0">
				<div style="margin: 0 auto;">No Data</div>
			</template>
		</div>
	</div>
</template>

<script>
import 'moment-timezone'
import {
  getAuthorWorksList,
  getBooksReadDatas
} from '../../common/api/works.js'
export default {
  props: {
    isOperator: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // dialogFormVisible: false,
      // form: {
      // 	name: '',
      // },
      // formLabelWidth: '120px',
      userInfo: this.$store.state.userInfo,
      baseApi: process.env.VUE_APP_NOVEL_API,
      worksSettingList: [],
      settingList: '',
      reqWorksData: { // 请求作品参数
        data: {
          page: 1,
          limit: 15,
          works: {
            userId: this.$store.state.userInfo.id
          }

        }
      },
      worksList: [], // 作品数据
      // isOperator: false, //责编true作家false
      search: {

      }
    }
  },
  created () {
    this.loadList()
    console.log('userInfo', this.userInfo)
  },
  methods: {
    numberFormat (num) {
      if (num >= 1000) {
        return this.toFixed1(num / 1000) + 'k'
      } else {
        return num
      }
    },
    toFixed1 (num) {
      num = num.toString()
      const index = num.indexOf('.')
      if (index !== -1) {
        num = num.substring(0, index + 2)
        return parseFloat(num).toFixed(1)
      } else {
        num = num.substring(0)
        return parseFloat(num)
      }
    },
    formatDate (Time) { // 获得UTC的时间
      const moment = require('moment-timezone')

      // console.log(" moment.tz.names()", moment.tz.names());

      if (Time == null) {
        return null
      }
      var timezone = 'Asia/Shanghai'
      const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss') // 清除 timezone 信息
      const Shanghailocal = moment.tz(clean, timezone)
      return Shanghailocal.tz('UTC').format('YYYY-MM-DD HH:mm:ss')
    },
    formatlocalDate (Time) { // 获得当地的时间
      const moment = require('moment-timezone')

      if (Time == null) {
        return null
      }
      // console.log("localTimezone",moment.tz.guess());

      var timezone = 'Asia/Shanghai'
      const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss') // 清除 timezone 信息
      // console.log("clearTimezone",moment.tz.guess());
      const Shanghailocal = moment.tz(clean, timezone)

      var localTimeZone = moment.tz.guess()

      // return  Shanghailocal.tz(localTimeZone).format('YYYY-MM-DD HH:mm:ss')
      return Shanghailocal.tz(localTimeZone).format('YYYY-MM-DD')
    },
    loadList () {
      if (this.isOperator) {
        this.reqWorksData.data.works.userId = 0
      }
      this.reqWorksData.data.works.worksName = this.search.name
      getAuthorWorksList(this.reqWorksData).then(res => {
        console.log('res', res)
        if (res.code == 0) {
          // this.worksList = res.data
          this.getBooksReadDatas(res.data) // 根据作者ID 去获取对应的作品收藏数 评论数啥的
        } else {

        }
      })
    },
    getBooksReadDatas (worksList) {
      let data = {
        data: {
          ids: [this.$store.state.userInfo.id]
        }
      }
      getBooksReadDatas(data).then(res => {
        for (let i in worksList) { // 先把属性加上设置为0
          worksList[i].works.readCount = 0
          worksList[i].works.shelfCount = 0
          worksList[i].works.commentCount = 0
        }
        if (res.code == 0) {
          for (let i in res.data) {
            for (let j in worksList) {
              if (res.data[i].workId == worksList[j].works.id) {
                worksList[j].works.readCount = res.data[i].readCount
                worksList[j].works.shelfCount = res.data[i].shelfCount
                worksList[j].works.commentCount = res.data[i].commentCount
              }
            }
          }
          this.worksList = worksList
		  console.log('worksList123', this.worksList)
        }
      })
    },
    handleClick () {
      console.log('this.search', this.search)
      this.loadList()
    },
    deleteSetting () {

    },
    editSetting () {

    },
    // 编辑
    toEditor (item) {
      console.log('item', item)
      this.$router.push({
        path: '/work/edit',
        query: {
          params: JSON.stringify({
            id: item.works.id
          })
        }
      })
    },
    // 去作品设定
    toSetting (item) {
      console.log('item', item)
      this.$router.push({
        path: '/work/setup',
        query: {
          params: JSON.stringify({
            id: item.works.id,
            settings: item.settings
          })
        }
      })
    },
    // 去作品签署设定
    tosigning (item) {
      console.log('item', item)
      this.$router.push({
        path: '/work/signingManagement',
        query: {
          params: JSON.stringify({
            bookId: item.works.id,
            isOperator: this.isOperator
          })
        }
      })
    },
    // 去作品签署设定
    toViewProcess (item) {
      console.log('item', item)
      this.$router.push({
        path: '/process/process',
        query: {
          params: JSON.stringify({
            bookId: item.works.id,
            isOperator: this.isOperator
          })
        }
      })
    },

    addSettingByBook () {
      this.$router.push({
        path: '/work/setup'
      })
    },
    toPublished (work) { // 已发布
      console.log('发布数据', work)
      this.$router.push({
        path: '/work/writing?id=' + work.works.id + '&worksName=' + work.works.worksName +
						'&hasPublished=' + work.hasPublished +
						'&listtype=1'
      })
    },
    toWriting (work) {
      this.$router.push({
        path: '/work/writing?id=' + work.works.id + '&worksName=' + work.works.worksName +
						'&listtype=1 &buttontype=add'
      })
    },
    // 增加作品分类设定
    addWorktoset () {
      console.log('增加作品分类设定')
      this.$router.push({
        path: '/work/writing'
      })
    },
    btnSettings () {
      console.log('e', e)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
	.content {
		padding: 20px;

		.search {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
			margin-bottom: 20px;
		}

		.items {
			margin-bottom: 20px;
		}

		.list {
			// height: 250px;
			display: flex;
			justify-content: flex-start;
			border-bottom: 1px solid #EAEAEA;
			margin-bottom: 20px;

			.work-left {
				width: 160px;

				.work-image {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 130px;
					height: 170px;
					// border: 1px solid #eee;
					overflow: hidden;
					border-radius: 6px;
					box-shadow: 3px 3px 5px #ccc;

					img {
						width: 100%;
						height: 100%;

					}
				}

				.work_bottom {
					// width: 200px;
					// height: 50px;
					margin: 25px;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.Word_Count {
						.Word_Counts {
							font-size: 24px;
							font-weight: 500;
						}

					}

					.vipBox {
						margin-right: 80px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						&-label {
							font-size: 18px;
							margin-bottom: 5px;

						}

						&-value {
							font-size: 18px;
							font-weight: bold;
						}

					}

					.statusBox {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						&-label {
							font-size: 18px;
							margin-bottom: 5px;
						}

						&-value {
							div {
								width: max-content;
								font-size: 18px;
								font-weight: bold;
							}
						}
					}
				}
			}

			.work-right {
				flex: 1;
				display: flex;
				justify-content: space-between;
				align-content: center;

				.work-right-info {
					height: 170px;
					width: 400px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
				}

				.name {
					font-size: 18px;
					font-weight: bold;
					padding: 10px 0 5px 0;
				}

				.chapter {
					font-size: 16px;
					// margin-bottom: 2px;
					color: #656565;
				}

				.wordCountStyle {
					display: flex;
					align-items: flex-end;
					justify-content: flex-start;

					&-label {}

					&-num {
						font-size: 24px;
						font-weight: 500;
					}
				}

				.shoucang {
					font-size: 14px;
					color: #656565;
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;

					.workCount {
						margin-right: 10px;
						display: flex;

						img {
							width: 20px;
							height: 20px;
							margin-right: 5px;
						}

						span {
							line-height: 20px;
						}
					}

					.workCount1 {
						margin-right: 10px;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 17px;
							height: 17px;
							margin-right: 5px;
						}

						span {
							line-height: 20px;
						}
					}

				}

				.doms {
					display: flex;
					justify-content: space-between;
					align-items: end;
					margin-bottom: 30px;
					width: 100%;
					float: right;

					.sheding {
						color: #FF8900;
					}

					.btn {

						// bottom: 10px;
						button {
							margin-right: 20px;
						}

						.info-updata-btn {
							// margin-right: 5px;
						}
					}
				}
			}
		}

		.setting {
			border-bottom: 1px solid #EAEAEA;
			padding-bottom: 5px;

			.row {
				margin-bottom: 20px;
			}

			.value-item {
				border: 1px solid #C4C4C4;
				position: relative;
				min-height: 40px;
				padding: 15px;
				margin-bottom: 15px;

				.item-btn {
					position: absolute;
					top: 8px;
					right: 15px;
					font-size: 13px;
					color: #C4C4C4;

					span {
						margin-left: 10px;
						cursor: pointer;
					}

					span:hover {
						color: #8a898b;
					}
				}

				.info {
					width: 70%;

					.name {
						font-size: 14px;
						color: #656565;
						border: 0px;
						line-height: 28px;
					}

					.item-content {
						color: #C4C4C4;
						font-size: 12px;
						line-height: 18px;
						border: 0px;
					}
				}
			}
		}
	}
</style>
